import { Button } from '@/components/ui/button';
import { useLanguage } from '@/lib/useLanguage';
import type { Language } from '@/lib/translations';
import { trackEvent } from '@/lib/tracking';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  const languages: { code: Language; flag: string; label: string }[] = [
    { code: 'no', flag: '/images/norway-flag.png', label: 'Norwegian' },
    { code: 'th', flag: '/images/thailand-flag.png', label: 'Thai' },
    { code: 'en', flag: 'https://flagcdn.com/w40/gb.png', label: 'English' }
  ];

  return (
    <div 
      role="listbox" 
      aria-label="Language"
      className="relative inline-flex items-center gap-2"
    >
      {languages.map((lang) => (
        <Button
          key={lang.code}
          onClick={() => {
            if (lang.code !== language) trackEvent('language_switch', { from_language: language, to_language: lang.code });
            setLanguage(lang.code);
          }}
          variant="ghost"
          size="default"
          title={lang.label}
          className={`
            relative z-10 w-12 h-9 p-1 transition-all duration-300 overflow-visible hover:bg-transparent
            ${language === lang.code 
              ? 'scale-105 ring-2 ring-[hsl(var(--gold))] shadow-[0_4px_16px_-2px_rgba(234,179,8,0.6)]' 
              : ''
            }
          `}
          style={{ borderRadius: '24px' }}
          aria-selected={language === lang.code}
          aria-label={`Switch to ${lang.label}`}
        >
          <img 
            src={lang.flag} 
            alt={lang.label}
            className="w-full h-full object-cover relative z-10"
            style={{ borderRadius: '24px' }}
          />
        </Button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
